/*
  Compra Rápida — Elétrika (22/09/2026)
  -------------------------------------
  Painel onde a cliente monta a sacola escolhendo cor, tamanho e quantidade sem abrir
  a página de cada produto.

  Decisões que valem registro:
  - o carrinho usa window.EletrikaCart (a mesma ponte dos cards), então a animação de
    voar para a sacola e a abertura da gaveta continuam iguais ao resto do site;
  - a troca de cor busca /products/handle.js e reescreve o item no lugar: nada de recarregar
    o painel inteiro nem duplicar markup de todas as cores no HTML;
  - o desconto por faixa é PROJEÇÃO na tela; quem aplica de verdade é o desconto automático
    da Shopify ou o cupom configurado, e o rodapé avisa isso.
*/
(function () {
  'use strict';

  function money(centavos) {
    return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function iniciar(raiz) {
    if (!raiz || raiz.__cre) return;
    raiz.__cre = true;

    var painel = raiz.querySelector('.cre__painel');
    var veu = raiz.querySelector('[data-cre-veu]');
    var lista = raiz.querySelector('[data-cre-lista]');
    var pixPct = parseInt(raiz.getAttribute('data-pix'), 10) || 0;
    var cupom = raiz.getAttribute('data-cupom') || '';
    var irCheckout = raiz.getAttribute('data-ir-checkout') === 'true';
    var lembrar = raiz.getAttribute('data-lembrar') === 'true';
    var metaFrete = parseInt(raiz.getAttribute('data-meta-frete'), 10) || 0;
    var CHAVE = 'eletrika:compra-rapida';

    var faixas = [].slice.call(raiz.querySelectorAll('.cre__faixa'))
      .map(function (f) {
        return { qtd: parseInt(f.getAttribute('data-qtd'), 10) || 0, pct: parseInt(f.getAttribute('data-pct'), 10) || 0 };
      })
      .filter(function (f) { return f.qtd > 0 && f.pct > 0; })
      .sort(function (a, b) { return a.qtd - b.qtd; });

    // ---------- abrir e fechar ----------
    var ultimoFoco = null;
    function abrir() {
      ultimoFoco = document.activeElement;
      veu.hidden = false; painel.hidden = false;
      requestAnimationFrame(function () { veu.classList.add('is-on'); painel.classList.add('is-on'); });
      document.documentElement.style.overflow = 'hidden';
      var f = painel.querySelector('.cre__fechar');
      if (f) f.focus();
    }
    function fechar() {
      veu.classList.remove('is-on'); painel.classList.remove('is-on');
      document.documentElement.style.overflow = '';
      setTimeout(function () { veu.hidden = true; painel.hidden = true; }, 260);
      if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
    }
    raiz.addEventListener('cre:abrir', abrir);
    [].slice.call(raiz.querySelectorAll('[data-cre-abrir]')).forEach(function (b) {
      b.addEventListener('click', abrir);
    });
    veu.addEventListener('click', fechar);
    [].slice.call(raiz.querySelectorAll('[data-cre-fechar]')).forEach(function (b) {
      b.addEventListener('click', fechar);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !painel.hidden) fechar();
    });

    // ---------- abas ----------
    [].slice.call(raiz.querySelectorAll('[data-cre-aba]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-cre-aba');
        [].slice.call(raiz.querySelectorAll('[data-cre-aba]')).forEach(function (o) {
          var on = o === b;
          o.classList.toggle('is-on', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        [].slice.call(raiz.querySelectorAll('[data-cre-painel]')).forEach(function (p) {
          p.classList.toggle('is-off', p.getAttribute('data-cre-painel') !== i);
        });
      });
    });

    // ---------- busca ----------
    var busca = raiz.querySelector('[data-cre-busca]');
    if (busca) {
      busca.addEventListener('input', function () {
        var termo = busca.value.trim().toLowerCase();
        [].slice.call(raiz.querySelectorAll('[data-cre-item]')).forEach(function (it) {
          var nome = (it.getAttribute('data-nome') || '').toLowerCase();
          it.classList.toggle('is-hidden', termo !== '' && nome.indexOf(termo) === -1);
        });
      });
    }

    // ---------- seleção ----------
    var escolhidos = {};   // { variantId: {qtd, preco, nome, foto} }

    function salvar() {
      if (!lembrar) return;
      try { window.localStorage.setItem(CHAVE, JSON.stringify(escolhidos)); } catch (e) {}
    }
    function restaurar() {
      if (!lembrar) return;
      try {
        var d = JSON.parse(window.localStorage.getItem(CHAVE) || '{}');
        Object.keys(d).forEach(function (vid) {
          var botao = raiz.querySelector('[data-vid="' + vid + '"]');
          if (!botao) return;              // produto saiu da lista: ignora
          escolhidos[vid] = d[vid];
          var item = botao.closest('[data-cre-item]');
          marcarTam(item, botao);
          var input = item.querySelector('[data-cre-input]');
          if (input) input.value = d[vid].qtd;
        });
        totalizar();
      } catch (e) {}
    }

    function marcarTam(item, botao) {
      [].slice.call(item.querySelectorAll('[data-cre-tam]')).forEach(function (b) {
        b.classList.toggle('is-on', b === botao);
      });
      var st = item.querySelector('[data-cre-stepper]');
      var aviso = item.querySelector('[data-cre-aviso]');
      if (st) st.hidden = false;
      if (aviso) aviso.hidden = true;
    }

    function idAtual(item) {
      var on = item.querySelector('[data-cre-tam].is-on');
      return on ? on.getAttribute('data-vid') : null;
    }

    function totalizar() {
      var qtd = 0, subtotal = 0;
      Object.keys(escolhidos).forEach(function (vid) {
        qtd += escolhidos[vid].qtd;
        subtotal += escolhidos[vid].qtd * escolhidos[vid].preco;
      });

      var pct = 0;
      faixas.forEach(function (f) { if (qtd >= f.qtd) pct = f.pct; });
      var desconto = Math.round(subtotal * pct / 100);
      var total = subtotal - desconto;

      raiz.querySelector('[data-cre-qtd]').textContent = qtd ? '(' + qtd + (qtd > 1 ? ' peças)' : ' peça)') : '';
      raiz.querySelector('[data-cre-subtotal]').textContent = money(subtotal);
      raiz.querySelector('[data-cre-total]').textContent = money(total);

      var linhaDesc = raiz.querySelector('[data-cre-linha-desc]');
      if (linhaDesc) {
        linhaDesc.hidden = pct === 0;
        raiz.querySelector('[data-cre-pct]').textContent = '(' + pct + '% OFF)';
        raiz.querySelector('[data-cre-desconto]').textContent = '- ' + money(desconto);
      }

      var linhaPix = raiz.querySelector('[data-cre-linha-pix]');
      if (linhaPix) {
        linhaPix.hidden = qtd === 0 || pixPct === 0;
        raiz.querySelector('[data-cre-pix]').textContent = money(Math.round(total * (100 - pixPct) / 100));
      }

      var frete = raiz.querySelector('[data-cre-frete]');
      if (frete && metaFrete > 0) {
        frete.hidden = qtd === 0;
        var falta = metaFrete - total;
        var pctBarra = Math.max(0, Math.min(100, total / metaFrete * 100));
        raiz.querySelector('[data-cre-frete-preenche]').style.width = pctBarra + '%';
        var msg = falta > 0
          ? (raiz.getAttribute('data-msg-frete-falta') || 'Faltam {valor}').replace('{valor}', money(falta))
          : (raiz.getAttribute('data-msg-frete-ok') || 'Frete grátis!');
        raiz.querySelector('[data-cre-frete-txt]').textContent = msg;
      }

      [].slice.call(raiz.querySelectorAll('[data-cre-badge]')).forEach(function (b) {
        b.hidden = qtd === 0; b.textContent = qtd;
      });
      raiz.querySelector('[data-cre-add]').disabled = qtd === 0;
      raiz.querySelector('[data-cre-limpar]').disabled = qtd === 0;
      salvar();
    }

    // ---------- eventos dos itens (delegação: itens são reescritos na troca de cor) ----------
    lista.addEventListener('click', function (e) {
      var alvo = e.target.closest('button');
      if (!alvo) return;
      var item = alvo.closest('[data-cre-item]');
      if (!item) return;

      // tamanho
      if (alvo.hasAttribute('data-cre-tam') && !alvo.disabled) {
        marcarTam(item, alvo);
        var vid = alvo.getAttribute('data-vid');
        if (!escolhidos[vid]) {
          var input = item.querySelector('[data-cre-input]');
          if (input) input.value = 0;
        } else {
          item.querySelector('[data-cre-input]').value = escolhidos[vid].qtd;
        }
        return;
      }

      // quantidade
      if (alvo.hasAttribute('data-cre-mais') || alvo.hasAttribute('data-cre-menos')) {
        var vidQ = idAtual(item);
        if (!vidQ) return;
        var campo = item.querySelector('[data-cre-input]');
        var atual = parseInt(campo.value, 10) || 0;
        var novo = alvo.hasAttribute('data-cre-mais') ? atual + 1 : Math.max(0, atual - 1);
        campo.value = novo;
        var btnTam = item.querySelector('[data-cre-tam].is-on');
        if (novo === 0) {
          delete escolhidos[vidQ];
        } else {
          escolhidos[vidQ] = {
            qtd: novo,
            preco: parseInt(btnTam.getAttribute('data-preco'), 10) || 0,
            nome: item.getAttribute('data-nome') + ' · ' + btnTam.textContent.trim(),
            foto: (item.querySelector('[data-cre-foto] img') || {}).src || ''
          };
        }
        totalizar();
        return;
      }

      // troca de cor: busca o produto irmão e reescreve o item
      if (alvo.hasAttribute('data-cre-cor')) {
        var handle = alvo.getAttribute('data-cre-cor');
        if (item.getAttribute('data-handle') === handle) return;
        alvo.disabled = true;
        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) { trocarCor(item, p, alvo); })
          .catch(function () { window.location.href = '/products/' + handle; })
          .then(function () { alvo.disabled = false; });
      }
    });

    function trocarCor(item, p, botao) {
      var idxTam = parseInt(item.getAttribute('data-idx-tam'), 10) || 0;

      // os que já estavam escolhidos nesta linha saem: as variantes mudaram de produto
      [].slice.call(item.querySelectorAll('[data-cre-tam]')).forEach(function (b) {
        delete escolhidos[b.getAttribute('data-vid')];
      });

      item.setAttribute('data-handle', p.handle);
      item.setAttribute('data-pid', p.id);
      item.setAttribute('data-nome', p.title);
      item.querySelector('[data-cre-nome]').textContent = p.title;
      item.querySelector('[data-cre-nome]').href = '/products/' + p.handle;

      var foto = item.querySelector('[data-cre-foto]');
      if (foto) {
        foto.href = '/products/' + p.handle;
        var img = foto.querySelector('img');
        if (img && p.featured_image) img.src = p.featured_image;
      }

      var disp = (p.variants || []).filter(function (v) { return v.available; })[0] || p.variants[0];
      if (disp) {
        var pix = item.querySelector('[data-cre-pix-val]');
        if (pix) pix.textContent = money(Math.round(disp.price * (100 - pixPct) / 100));
        var preco = item.querySelector('[data-cre-preco]');
        if (preco) preco.textContent = money(disp.price);
        var de = item.querySelector('[data-cre-de]');
        if (de) de.textContent = disp.compare_at_price > disp.price ? money(disp.compare_at_price) : '';
      }

      var tams = item.querySelector('[data-cre-tams]');
      tams.innerHTML = (p.variants || []).map(function (v) {
        var rotulo = (v.options && v.options[idxTam]) || v.title;
        return '<button type="button" class="cre__tam" data-cre-tam data-vid="' + v.id + '" data-preco="' + v.price +
          '" data-de="' + (v.compare_at_price || 0) + '"' + (v.available ? '' : ' disabled aria-disabled="true"') +
          '>' + rotulo + '</button>';
      }).join('');

      var st = item.querySelector('[data-cre-stepper]');
      if (st) { st.hidden = true; item.querySelector('[data-cre-input]').value = 0; }
      var aviso = item.querySelector('[data-cre-aviso]');
      if (aviso) aviso.hidden = false;

      [].slice.call(item.querySelectorAll('[data-cre-cor]')).forEach(function (b) {
        b.classList.toggle('is-on', b === botao);
      });
      totalizar();
    }

    // ---------- limpar ----------
    raiz.querySelector('[data-cre-limpar]').addEventListener('click', function () {
      escolhidos = {};
      [].slice.call(raiz.querySelectorAll('[data-cre-input]')).forEach(function (i) { i.value = 0; });
      [].slice.call(raiz.querySelectorAll('[data-cre-tam].is-on')).forEach(function (b) { b.classList.remove('is-on'); });
      [].slice.call(raiz.querySelectorAll('[data-cre-stepper]')).forEach(function (s) { s.hidden = true; });
      [].slice.call(raiz.querySelectorAll('[data-cre-aviso]')).forEach(function (a) { a.hidden = false; });
      totalizar();
    });

    // ---------- adicionar ----------
    var btnAdd = raiz.querySelector('[data-cre-add]');
    var erro = raiz.querySelector('[data-cre-erro]');
    btnAdd.addEventListener('click', function () {
      var itens = Object.keys(escolhidos).map(function (vid) {
        return { id: parseInt(vid, 10), quantity: escolhidos[vid].qtd };
      });
      if (!itens.length) return;
      erro.hidden = true;
      var rotulo = btnAdd.querySelector('.cre__cta-txt').textContent;
      btnAdd.disabled = true;
      btnAdd.querySelector('.cre__cta-txt').textContent = 'Adicionando...';

      var primeira = escolhidos[Object.keys(escolhidos)[0]];
      var promessa = window.EletrikaCart
        ? window.EletrikaCart.add(itens, { source: btnAdd, image: primeira && primeira.foto, flyStyle: 'fly-to-cart--quick' })
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: itens })
          }).then(function (r) { if (!r.ok) throw new Error('Falha ao adicionar'); return r.json(); });

      promessa
        .then(function () {
          escolhidos = {};
          try { window.localStorage.removeItem(CHAVE); } catch (e) {}
          if (irCheckout || cupom) {
            window.location.href = cupom
              ? '/discount/' + encodeURIComponent(cupom) + '?redirect=/checkout'
              : '/checkout';
            return;
          }
          btnAdd.querySelector('.cre__cta-txt').textContent = 'Adicionado ✓';
          setTimeout(function () {
            btnAdd.querySelector('.cre__cta-txt').textContent = rotulo;
            fechar();
            [].slice.call(raiz.querySelectorAll('[data-cre-input]')).forEach(function (i) { i.value = 0; });
            [].slice.call(raiz.querySelectorAll('[data-cre-tam].is-on')).forEach(function (b) { b.classList.remove('is-on'); });
            [].slice.call(raiz.querySelectorAll('[data-cre-stepper]')).forEach(function (s) { s.hidden = true; });
            totalizar();
          }, 1200);
        })
        .catch(function (e) {
          btnAdd.disabled = false;
          btnAdd.querySelector('.cre__cta-txt').textContent = rotulo;
          erro.hidden = false;
          erro.textContent = (e && e.message) || 'Não foi possível adicionar. Tente de novo.';
        });
    });

    restaurar();
    totalizar();
  }

  function iniciarTodos(escopo) {
    [].slice.call((escopo || document).querySelectorAll('[data-cre]')).forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  } else {
    iniciarTodos();
  }
  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();
